import React from 'react'
import styled from 'styled-components'

import Panel from '../Panel/Panel'
import Loader from '../../Loader/Loader'

import { SCREEN_SIZE } from '../../../lib/Media'

import HowToUse from '../sections/HowToUse'
import Guest from './Guest'
import Member from './Member'
import Error from './Error'
import { getEmail } from '../../../utils/Utils'

const Hero = styled.div`
  ${SCREEN_SIZE.From.Desktop} {
    display: flex;
    background: ${props =>
        props.isMember
          ? "url('https://media.nedigital.sg/fairprice/images/f9e0d467-a7cd-4149-ae76-04ae03865c40/login_landing_page_banner.jpg')"
          : "url('https://media.nedigital.sg/fairprice/images/f2e05c6a-672c-437c-9295-ad9cc7783703/jwc-banner@2x.jpg')"}
      no-repeat center center;
    background-size: cover;
    margin-bottom: 3.75rem;
  }
`
const HeroPanel = styled.div`
  ${SCREEN_SIZE.From.Desktop} {
    padding: 1.25rem;
    width: 25.625rem;
    margin-left: auto;
    min-height: 36.25rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
`
const MemberDiscount = styled.img`
  width: 100%;
  height: auto;
  display: block;
`

const AboutBanner = styled.img`
  ${SCREEN_SIZE.Below.Tablet} {
    display: none;
  }

  width: 100%;
  height: auto;
  margin-bottom: 2rem;
  margin-bottom: 1rem;
`

const ScreenManager = ({ loaded, status, data, accountData, error, track }) => {
  let isMember
  if (status === 'guest' || status === 'user') {
    isMember = false
  }
  if (status === 'member') {
    isMember = true
  }

  if (status === 'pending') {
    return (
      <div css="margin-top: 3rem;">
        <Loader />
      </div>
    )
  }

  const email = getEmail(accountData)

  return (
    <React.Fragment>
      <Hero isMember={isMember}>
        {loaded ? (
          error ? (
            <HeroPanel>
              <Error error={error} />
            </HeroPanel>
          ) : (
            <HeroPanel>
              {status !== 'member' && (
                <Guest status={status} data={data} track={track} />
              )}
              {status === 'member' && (
                <Member email={email} data={data} track={track} />
              )}
            </HeroPanel>
          )
        ) : (
          <HeroPanel>
            <Panel>
              <div data-testid="panel-loader" css="margin: auto">
                <Loader />
              </div>
            </Panel>
          </HeroPanel>
        )}
      </Hero>

      {!isMember && (
        <AboutBanner
          src={
            'https://media.nedigital.sg/fairprice/images/b150d298-71a0-4a9c-9ed1-cfb4300b4076/about.jpg'
          }
        />
      )}

      {!isMember && (
        <MemberDiscount
          src={
            'https://media.nedigital.sg/fairprice/images/4dc8e6e6-d09d-4967-9f5a-4ef0f3c58999/jwc_benefit_list.jpg'
          }
          className="ndsHidden-xs-down"
          alt="Member discounts"
          title="Member discounts"
        />
      )}
      {!isMember && (
        <MemberDiscount
          src={
            'https://media.nedigital.sg/fairprice/images/c6bf37e7-d6eb-41fa-88a2-85fbd2bd0d58/jwc_benefit_list_mobile.jpg'
          }
          className="ndsHidden-s-up"
          alt="Member discounts"
          title="Member discounts"
        />
      )}

      {isMember && (
        <React.Fragment>
          <HowToUse />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default ScreenManager
